import { firebase } from "@data/firebase/config";
import { collection, limit, onSnapshot, orderBy, query } from "firebase/firestore";
import { fireabseAdapter } from "./firebaseAdapter";
import { DatabaseCloseRoutesLogRepository } from "@domain/repositories/DatabaseCloseRoutesLogRepository";
import { CloseRoutesLogStore } from "@domain/stores/CloseRoutesLogStore";
import { CloseRoutesLog } from "@domain/models/CloseRoutesLog";

export class FirebaseCloseRoutesLogRepository implements DatabaseCloseRoutesLogRepository {
  constructor(private readonly closeRoutesLogStore: CloseRoutesLogStore) {}

  watchCloseRoutesLogsAdmin() {
    const consulta = query(
      collection(firebase.db, "closeRoutesLogs"),
      orderBy("createdAt", "desc"),
      limit(100)
    );

    onSnapshot(
      consulta,
      async (querySnapshot) => {
        const mappedDocs = fireabseAdapter.mapFirebaseDoc<CloseRoutesLog>(querySnapshot);

        this.closeRoutesLogStore.updateCloseRoutesLogs(mappedDocs);
      },
      (error) => console.log("watchCloseRoutesLogsAdmin error", error)
    );
  }
}
